import { setScreen, card, title, subtitle, btn, el, colors, errorMsg, divider, row } from "./app";
import { buildAllegianceToggle, buildRosterForm } from "./rosterForm";
import { showLobby } from "./lobby";
import { showWaitingRoom } from "./waitingRoom";
import { createGame } from "../api/games";

export function showCreateGame(): void {
  const c = card(520);

  c.appendChild(title("Create Game"));
  c.appendChild(subtitle("Set up your team, then share the game code with your opponent."));
  c.appendChild(divider());

  // Allegiance
  const { container: allegianceEl, getAllegiance } = buildAllegianceToggle();
  c.appendChild(allegianceEl);

  // Roster
  const { container: rosterEl, getPlayers, updateAllegiance } = buildRosterForm("ELF");
  // Keep roles in sync with allegiance
  (allegianceEl.querySelectorAll("button") as NodeListOf<HTMLButtonElement>).forEach((b) => {
    b.addEventListener("click", () => updateAllegiance(getAllegiance()));
  });
  // Re-wire with a MutationObserver is complex — instead patch the buttons after mount.
  // We rely on the allegiance toggle's onChange callback instead.
  c.appendChild(rosterEl);

  c.appendChild(divider());

  const err = errorMsg();
  c.appendChild(err);

  // Action row
  const backBtn = btn("← Back", "ghost");
  backBtn.addEventListener("click", showLobby);

  const createBtn = btn("Create Game", "primary");
  createBtn.style.marginLeft = "auto";

  c.appendChild(row(backBtn, createBtn));

  // Wire allegiance onChange to roster
  // (re-attach since we need the reference from buildAllegianceToggle)
  // We rebuild the toggle with the onChange wired properly.
  // The toggle was already built above, so instead listen on click directly:
  c.querySelectorAll<HTMLButtonElement>("[data-value]").forEach((b) => {
    b.addEventListener("click", () => {
      // Small delay so getAllegiance() reflects the new value
      requestAnimationFrame(() => updateAllegiance(getAllegiance()));
    });
  });

  createBtn.addEventListener("click", async () => {
    err.textContent = "";
    const allegiance = getAllegiance();
    const players = getPlayers();

    if (players.length === 0) {
      err.textContent = "Add at least one player.";
      return;
    }

    createBtn.disabled = true;
    createBtn.textContent = "Creating…";

    try {
      const response = await createGame({ allegiance, players });
      showWaitingRoom(response.gameId, response.joinCode, response.homeToken);
    } catch (e) {
      err.textContent = e instanceof Error ? e.message : "Failed to create game.";
      createBtn.disabled = false;
      createBtn.textContent = "Create Game";
    }
  });

  setScreen(c);
}
